
import { Component, Vue } from 'vue-property-decorator';
import BranchFilter from './filters/branch-filter.vue';
import { Filter } from '../lib/interfaces/search/Filter';
import { container } from '../lib/container';
import { SearchStorage } from '../lib/core/storage/SearchStorage';
import { ContainerTypes } from '../lib/core/types/ContainerTypes';
import { getConfig } from '../lib/ConfigLoader';
import { IConfig } from '../lib/presets/IConfig';

const storage = container.get<SearchStorage>(ContainerTypes.SearchStorage);

@Component({
	components: { BranchFilter }
})
export default class FiltersView extends Vue {
	private onClickOutsideListener: ((event: Event) => void) | undefined;

	branchFilters: Filter[];
	config: IConfig;

	constructor(options?: any) {
		super(options);
		this.config = getConfig();
		this.branchFilters = this.config.filters;
	}

	getActiveFilters() {
		return this.config.filters.filter((filter: Filter) => storage.filters.indexOf(filter.label) > -1);
	}

	getActiveBranchCodes() {
		// 1. take all branch codes from active filters array (checked filter checkboxes)
		// 2. take only the difference sum between val and result and add it to the result array
		return this.getActiveFilters()
			.map((filter: Filter) => filter.branches)
			.reduce(
				(result, val) => (val.length > 0 ? result.concat(val.filter(v => !result.includes(v))) : result),
				[]
			);
	}

	getActiveDataFilters() {
		// 1. take all branch codes from active filters array (checked filter checkboxes)
		// 2. take all filters with a dataFilters string
		// 3. filter dataFilters out that are already in the result array and add the new ones to the list.
		return this.getActiveFilters()
			.filter((filter: Filter) => filter.dataFilters)
			.map((filter: Filter) => filter.dataFilters)
			.reduce((result: string[], val) => (val && !result.includes(val) ? result.concat([val]) : result), []);
	}

	branchesChecked(filter: Filter) {
		if (storage.filters.indexOf(filter.label) < 0) {
			storage.filters.push(filter.label);
		}
		this.$emit('changed', this.getActiveBranchCodes(), this.getActiveDataFilters());
	}

	branchesUnchecked(filter: Filter) {
		const index = storage.filters.indexOf(filter.label);
		if (index >= 0) {
			storage.filters.splice(index, 1);
		}
		this.$emit('changed', this.getActiveBranchCodes(), this.getActiveDataFilters());
	}

	toggleFilters() {
		// remove old listener
		if (this.onClickOutsideListener !== undefined) {
			document.body.removeEventListener('click', this.onClickOutsideListener, false);
			this.onClickOutsideListener = undefined;
		}

		// listen on clicks outside of the filter-container
		// if (!this.isFiltersActive) {
		// 	}
		setTimeout(() => document.body.addEventListener('click', this.onClickOutside(), false), 100);
	}

	onResize() {}

	created() {
		// this.isFiltersActive = false;
	}

	mounted() {
		this.$nextTick(() => {
			this.$on('toggle', this.toggleFilters);
			window.addEventListener('resize', this.onResize);
			this.onResize();
		});
	}

	beforeDestroy() {
		this.$off('toggle', this.toggleFilters);
		window.removeEventListener('resize', this.onResize);
	}

	private onClickOutside() {
		return (this.onClickOutsideListener = event => {
			const el = event.target as HTMLElement;

			// no polyfill for IE! Deal with it!
			if (el.closest && !el.closest('.filter-container')) {
				// if (this.isFiltersActive) {
				// 	}
				this.toggleFilters();
			}
		});
	}
}
